import type { UserAbility } from '@/plugins/casl/AppAbility'

export const analyticsViewerAbilities: UserAbility[] = [
  // Auth
  {
    action: 'read',
    subject: 'Auth'
  },

  // Home
  {
    action: 'read',
    subject: 'Home'
  },
  {
    action: 'create',
    subject: 'Home'
  },
  {
    action: 'update',
    subject: 'Home'
  },
  {
    action: 'delete',
    subject: 'Home'
  }
]
